import { useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, ArrowLeft, CheckCircle2, KeyRound } from "lucide-react";
import { motion } from "framer-motion";

export default function ResetPassword() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-sm bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
        <div className="mb-8"><Logo /></div>

        <div data-testid="reset-info">
          <div className="mx-auto h-12 w-12 rounded-full bg-neutral-50 text-neutral-600 flex items-center justify-center mb-4">
            <KeyRound className="h-6 w-6" />
          </div>
          <h1 className="font-heading text-2xl font-semibold text-slate-900">Reset your password</h1>
          <p className="mt-2 text-sm text-slate-500">
            Once you're signed in, you can change your password anytime under
            <strong> Settings → Security</strong>.
          </p>
          <p className="mt-3 text-sm text-slate-500">
            Locked out of your account? Ask your workspace owner (or the platform team) to reset it for you from
            <strong> User Management</strong>.
          </p>
          <div className="mt-4 rounded-lg bg-neutral-50 border border-neutral-100 px-3 py-2 text-xs text-neutral-600">
            Signed in with Google? Just use <strong>Continue with Google</strong> — no password needed.
          </div>
        </div>

        <Link to="/login" className="mt-6 flex items-center justify-center gap-1.5 text-sm text-slate-500 hover:text-slate-700">
          <ArrowLeft className="h-4 w-4" /> Back to sign in
        </Link>
      </motion.div>
    </div>
  );
}
